import {axios} from '@js/utilities/axios.js';
export default {
	namespaced: true,
	state: {
		lock: {},
		dirty: {
			client_requirements_notes: false,
			job_offer_notes: false
		},
		cancellationTokens: {
			lock: null,
			unlock: null
		}
	},
	actions: {
		lock(context, id) {
			return new Promise((resolve, reject) => {
				if (context.state.cancellationTokens.lock) {
					context.state.cancellationTokens.lock.cancel();
				}

				context.state.cancellationTokens.lock = axios.CancelToken.source()

				axios.post(`/api/bookings/${id}/lock`, {
					cancelToken: context.state.cancellationTokens.lock.token
				}).then(response => {
					context.commit('setLock', response.data);
					resolve(response);
				}).catch(error => {
					reject(error);
				});
			})
		},
		unlock(context, id) {
			return new Promise((resolve, reject) => {
				if (context.state.cancellationTokens.unlock) {
					context.state.cancellationTokens.unlock.cancel();
				}

				context.state.cancellationTokens.unlock = axios.CancelToken.source()

				axios.post(`/api/bookings/${id}/unlock`, {
					cancelToken: context.state.cancellationTokens.unlock.token
				}).then(response => {
					context.commit('setLock', {});
					resolve(response);
				}).catch(error => {
					reject(error);
				});
			})
		},
		setClientRequirementsNoteDirty({commit}, value) {
			commit('setClientRequirementsNoteDirty', value)
		},
		setJobOfferNoteDirty({commit}, value) {
			commit('setJobOfferNoteDirty', value)
		},
		resetDirty({commit}) {
			commit('setClientRequirementsNoteDirty', false)
			commit('setJobOfferNoteDirty', false)
		}
	},
	mutations: {
		setLock(state, lock) {
			state.lock = lock;
		},
		setClientRequirementsNoteDirty(state, value) {
			state.dirty.client_requirements_notes = value
		},
		setJobOfferNoteDirty(state, value) {
			state.dirty.client_requirements_notes = value
		}
	},
	getters: {
		getLock(state) {
			return state.lock;
		},
		isAnyDirty(state) {
			return state.dirty.job_offer_notes || state.dirty.client_requirements_notes
		}
	}
}
